import {
  Tag,
  TagVariant,
  TextButton,
} from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { PaymentMethodSepa } from "@/api/opb/opbTypes";

interface SepaInfoProps {
  paymentMethod: PaymentMethodSepa;
  withEdit?: boolean;
  footer?: ReactNode;
}

export function SepaInfo({ paymentMethod, withEdit, footer }: SepaInfoProps) {
  const { t } = useTranslation("paymentMethods");

  return (
    <>
      <div className="pt-1 grow-0">
        <div className="w-9 h-5 border rounded-sm text-xs flex justify-center items-center font-medium border-grey-80">
          {t("SEPA")}
        </div>
      </div>
      <div className="pl-3 text-left relative grow shrink-0 w-24 flex-wrap">
        <div>{paymentMethod.nickname || null}</div>
        <div className="flex items-center">
          <div className="capitalize">{paymentMethod.type}</div>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="mx-2 rounded-sm font-normal h-5"
            />
          )}
        </div>
        <div>{paymentMethod.accountNumber}</div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            data-testid={`ach-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
